import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';

import HospitalDivision from './common/HospitalDivision';
import Hospital from '../list/divisionPageList/common/Division';
import Header from '../components/global/header';
import Footer from '../components/global/footer/index';
import { useHospitalPageApi } from './api';
import { useSetCity } from '../../hooks/useSetCity';

export function HospitalPageComponent({ hospital, getHospital, user, updateCity }) {
  const { city } = useSetCity({ user, updateCity });
  const { currentDivision, setCurrentDivision, divisionNotExists } = useHospitalPageApi({
    getHospital,
    hospital,
  });

  useEffect(() => {
    const full_name = hospital?.data?.full_name;
    if (full_name) {
      const prevTitle = document.title;
      const divisionName = currentDivision?.full_name;
      document.title = divisionName
        ? `${full_name} · ${divisionName} - Лікарі 24/7`
        : `${full_name} - Лікарі 24/7`;
      return () => { document.title = prevTitle; };
    }
  }, [hospital?.data?.full_name, currentDivision?.full_name]);

  if (!city || (hospital.loaded && !hospital.data) || divisionNotExists) return <Redirect to="/not-found-page" />;

  return (
    <div>
      <Header showTitle={false} />

      <main>
        <div className="institution-wrapper">
          <Container>
            {hospital.data && (
              <>
                <Hospital
                  institutionId={hospital.data.id}
                  full_name={hospital.data.full_name}
                  address={hospital.data.address}
                  remainedMedicinesUrl={hospital.data.remained_medicines_url}
                  phones={hospital.data.contacts.filter((contact) => contact.type === 'phone')}
                  photo={hospital.data.photo}
                  mapUrl={
                    hospital.data.address.lat && hospital.data.address.lon
                      ? `https://maps.google.com/maps/place/${hospital.data.address.lat},${hospital.data.address.lon}`
                      : null
                  }
                  rating={hospital.data.rating}
                  description={hospital.data.description}
                  city={city}
                  disableOwnLink
                  externalMapUrl
                />

                {!!hospital.data.divisions.length && (
                  <HospitalDivision
                    city={city}
                    currentDivision={currentDivision}
                    setCurrentDivision={setCurrentDivision}
                    divisions={hospital.data.divisions}
                  />
                )}
              </>
            )}
            {hospital.loaded && !hospital.data && <div className="institution-not-found">Лікарню не знайдено</div>}
          </Container>
        </div>
      </main>

      <Footer />
    </div>
  );
}
